import apiClient from "../clinet";

// Get current user
const getCurrentUser = async () => {
  const response = await apiClient.get("/auth/auth");
  return response.data;
};

// Login user
const loginUser = async (credentials: {
  username: string;
  password: string;
}) => {
  const response = await apiClient.post("/auth/login", credentials);
  return response.data;
};

// Logout user
const logoutUser = async () => {
  const response = await apiClient.post("/auth/logout");
  return response.data;
};

export default {
  getCurrentUser,
  loginUser,
  logoutUser,
};
